export const MOBILE_VIEWPORT_QUERY = '(max-width: 666px)'

export function getParentIsMobileViewport(): boolean {
  try {
    return window.matchMedia(MOBILE_VIEWPORT_QUERY).matches
  } catch {
    return false
  }
}
